import { SaveState } from '../constants';
import { ISaveStateAction } from '../interfaces/actions';

export const save = (): ISaveStateAction => ({ type: SaveState.SAVE_REQUEST });
export const saved = (): ISaveStateAction => ({ type: SaveState.SAVED });
export const dirty = (): ISaveStateAction => ({ type: SaveState.DIRTY });


// WEBPACK FOOTER //
// ./src/actions/SaveState.ts